var components
try {
  components = {
    uLoadmore: function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u-loadmore/u-loadmore" */ "@/uni_modules/uview-ui/components/u-loadmore/u-loadmore.vue"
      )
    },
    uEmpty: function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u-empty/u-empty" */ "@/uni_modules/uview-ui/components/u-empty/u-empty.vue"
      )
    },
    uButton: function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u-button/u-button" */ "@/uni_modules/uview-ui/components/u-button/u-button.vue"
      )
    },
    uImage: function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u-image/u-image" */ "@/uni_modules/uview-ui/components/u-image/u-image.vue"
      )
    },
    uPopup: function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u-popup/u-popup" */ "@/uni_modules/uview-ui/components/u-popup/u-popup.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var g0 = _vm.indexList.length
  var l0 =
    g0 > 0
      ? _vm.__map(_vm.indexList, function (item, index) {
          var $orig = _vm.__get_orig(item)
          var m0 = _vm.getPositionStr(item.position)
          var m1 = _vm.auditStatus(item.auditStatus)
          return {
            $orig: $orig,
            m0: m0,
            m1: m1,
          }
        })
      : null
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        g0: g0,
        l0: l0,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }